import * as React from "react";
import { cn } from "@/lib/utils";

/** Ghost field class stack: invisible at rest, full border and background on hover/focus. */
export const GHOST_FIELD_CLASSES =
  "bg-transparent border border-transparent " +
  "hover:border-input hover:bg-background " +
  "focus:border-ring focus:bg-background focus:outline-none focus:ring-1 focus:ring-ring " +
  "disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:border-transparent disabled:hover:bg-transparent";

interface GhostInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange"> {
  value: string;
  onChange: (value: string) => void;
  align?: "left" | "right";
}

export const GhostInput = React.forwardRef<HTMLInputElement, GhostInputProps>(
  ({ className, value, onChange, align = "left", disabled, ...props }, ref) => {
    return (
      <input
        ref={ref}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className={cn(
          "flex h-8 w-full rounded-md px-2 py-1 text-sm transition-colors",
          GHOST_FIELD_CLASSES,
          "placeholder:text-muted-foreground",
          align === "right" && "text-right",
          className,
        )}
        {...props}
      />
    );
  },
);

GhostInput.displayName = "GhostInput";
